import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import Cookies from "js-cookie";

const axios = require("axios").default;

import account from "./modules/account";
import session from "./modules/session";
import timers from "./modules/timers";

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== "production";
// TODO: set this to false when deploying
const debug = true;

/**
 * Configuring vuex-persist to make certain vuex data is persistent across
 * browser refresh
 */

// store session module in cookie
const vuexCookie = new VuexPersist({
  key: "cookieStore",
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) =>
    Cookies.set(key, state, {
      expires: 3, // expire in 3 days
      sameSite: "strict",
    }),
  modules: ["session"], // only store session module in cookie
});

// store other modules in local storage
const vuexLocal = new VuexPersist({
  key: "myLocalStore",
  storage: localStorage,
  modules: ["account"],
  // Filter out subscriptionOptions from being persisted since pricing can change
  filter: (mutation) => {
    // Don't persist setSubscriptionOptions mutations
    return mutation.type !== "account/setSubscriptionOptions";
  },
  reducer: (state) => ({
    account: {
      ...state.account,
      // Exclude subscriptionOptions from persisted state
      subscriptionOptions: undefined,
      // Keep other account data
      accountData: state.account.accountData,
      error: state.account.error,
      hideArchiveModal: state.account.hideArchiveModal,
      timerSortSelected: state.account.timerSortSelected,
    },
  }),
});

export default new Vuex.Store({
  modules: {
    account,
    session,
    timers,
  },
  strict: debug,
  plugins: [vuexCookie.plugin, vuexLocal.plugin],
});
